import joi from 'joi';
import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { job } from '../../../shared/job.def';

const response = joi.object({
	results: joi.array().items(job),
});

export const definition = makeDefinitionFor(
	'/job.json',
	{
		description: 'Get a list of jobs within a department',
		method: 'get',
		summary: 'Job list',
		tags: ['Job'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: response,
		},
		generateValidationError(),
	]
);
